import { AssessmentTestContextType } from '..';
import { closeOpenStepIntervals, queueForSync } from '../helpers';

export type TimeoutTestActionType = {
  type: 'TIMEOUT_TEST';
  timestamp: Date;
};

export function timeoutTestReducer(
  state: AssessmentTestContextType,
  action: TimeoutTestActionType
): AssessmentTestContextType {
  if (state.screen.type !== 'STEP') {
    throw new Error('TIMEOUT_TEST can only be called when in step screen');
  }
  const currentStep = state.steps[state.screen.stepIndex];
  return {
    ...state,
    ...queueForSync(state),
    screen: { type: 'TIMEOUT' },
    finishedAt: action.timestamp,
    finishReason: 'TIME_EXPIRED',
    steps: state.steps.map((s) =>
      s.id === currentStep.id
        ? closeOpenStepIntervals({ step: s, timestamp: action.timestamp })
        : s
    ),
  };
}
